<template>
  <bb-modal :visible="visible" @close="onClose()" flavor="card" color="white" publicSize="m" fullMobile>
    <div slot="heading" class="f-color-blue"> {{ translations.modalTitle }}</div>
    <div class="body">
      <bb-icon class="icon m-t-30" name="illustration-exclamation-mark" size="fluid" fill="mint-70"/>
      <div class="m-t-30 text-center f-color-gray">
        {{ translations.description }}
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <bb-button
        class="footer-button"
        :label="translations.no"
        data-testid="cancel-pending-no-button"
        inverted
        color="gray"
        display="block"
        @click="$emit('close')"/>
      <bb-button
        class="footer-button"
        :label="translations.yes"
        data-testid="cancel-pending-yes-button"
        :loading="isPendingPaymentsLoading"
        :disabled="isPendingPaymentsLoading"
        color="red"
        display="block"
        @click="onCancel"/>
    </div>
  </bb-modal>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { usePendingPaymentStore } from '@account/store/pendingPaymentStore'

export default {
  name: 'cancel-pending-payment-modal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    pendingPaymentIds: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState(usePendingPaymentStore, ['isPendingPaymentsLoading']),
    translations () {
      return {
        modalTitle: this.$pgettext('pending_payment_cancel', 'Cancel pending payment'),
        description: this.$pgettext('predefined_payment_delete',
          'You can\'t undo this action. Are you sure you want to cancel selected pending payment(s)?'),
        yes: this.$pgettext('pending_payment_cancel', 'Yes'),
        no: this.$pgettext('pending_payment_cancel', 'No'),
        notificationText: this.$pgettext('pending_payment_cancel', 'Pending payment(s) canceled')
      }
    }
  },
  methods: {
    ...mapActions(usePendingPaymentStore, ['cancelPendingPayments']),
    async onCancel () {
      await this.cancelPendingPayments(this.pendingPaymentIds)
      this.$notify({
        type: 'success',
        duration: 5000,
        text: this.translations.notificationText
      })
      this.onClose()
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.modal-footer {
  display: flex;
  flex-wrap: wrap;
  column-gap: 15px;
  padding: 10px;

  @media (max-width: $mobile-view-breaking-point) {
    padding: 30px;
    row-gap: 10px;
  }

  .footer-button {
    flex: 1 0 0;
  }
}

.body {
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon {
    max-width: 205px;
  }
}
</style>
